module.exports = __webpack_public_path__ + "img/sell.fac373a4.png";